import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import { CartProvider } from "./context/CartContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import SilverCollection from "./pages/SilverCollection";
import CartPage from "./pages/CartPage";
import FavouritesPage from "./pages/FavouritesPage";


export default function App(){
return (
<CartProvider>
<Router>
<Navbar />
<Routes>
<Route path="/" element={<SilverCollection/>} />
<Route path="/cart" element={<CartPage/>} />
<Route path="/favourites" element={<FavouritesPage/>} />
</Routes>
<Footer />
</Router>
</CartProvider>
);
}